/**
 * Responsible for rendering a list of underlying catalog items (products, materials, etc) which may be rendered in card or table view
 * Note that this may be a global product list, a list constrained within a season, a list of products within a grouped hierarchy ( Fabric -> Material -> Products for example), etc
 */
import {CatalogItemsCardView_LoadMore} from './CardView'
import {observer, React, classNames, styled, Suspense, useLocalStore, useEffect} from '@api'
import {NoProductsFound, ProductLandingComponent, LoadingIndicator, GroupByGroupStore, CatalogDataGridView, ErrorBoundary, useStores} from '@design-board/components'
import * as css from './CatalogItemsPanel.css'

export interface CatalogItemsPanelProps {
  /**
   * To avoid batching/cache collisions
   */
  queryKey?: string
  loading?: boolean | string
  offlineItemCount?: number
  onlineItemCount?: number
  path?: string[]
  scrollContainer?: HTMLElement
  itemStyle?: 'card' | 'flat'
  className?: string
  queryVariables?: any
  _source?: { _source: string[] }
  esIndex?: string
  disableAnimations?: boolean
  visible?: boolean
  expanded?: boolean
  preload?: boolean
  everVisible?: boolean
  onClickProduct?: (e: React.MouseEvent, id) => void
  level?: number // level of group by 0 for products
  groupStore?: GroupByGroupStore
  itemsPerClick?: number
  offline?: boolean
  extraHeader?: React.ReactNode
}

const EmptyResult = styled.div``

const CatalogItemsCardViewContainer = styled.div`
  display: flex;
  overflow: hidden;
  flex: 1;
  flex-direction: column;
  max-height: 100%;
`

export const CatalogItemsPanel = observer<CatalogItemsPanelProps>(function CatalogItemsPanel(props) {
  const {level, onlineItemCount, offlineItemCount, className, visible, extraHeader} = props,
    {
      catalog: {
        loadingCounts, settings, settings: {viewMode, levelOfDetail, activeSearchText}, groupBy: {isProductView},
        features: {renderer}, objectFit
      },
      catalog,
      filter: {hasFilterTerms}
    } = useStores(),
    store = useLocalStore(() => ({
      lastEmptyResult: null
    })),
    emptyResult = loadingCounts ? store.lastEmptyResult : !catalog.hasFinishedFirstLoad ? <LoadingIndicator />
                                : hasFilterTerms || !_.isEmpty(activeSearchText)
                                  ? <NoProductsFound key='no-products-found'/>
                                  : isProductView ? <ProductLandingComponent catalog={catalog} key='product-landing' searchText={activeSearchText}/> : null

  useEffect(() => {
    store.lastEmptyResult = emptyResult
  }, [emptyResult])

  // useEffect(() => {
  //   console.log(`Mount CatalogItemsPanel`, props.groupStore?.fullTitle)
  //   return () => console.log(`Unmount CatalogItemsPanel`, props.groupStore?.fullTitle)
  // }, [])

  // console.log({props, loadingCounts, offlineItemCount, onlineItemCount})
  return (<ErrorBoundary>
    <div data-level={level}
               data-visible={visible}
               data-type='CatalogItemsPanel'
               data-view={viewMode}
               data-count={onlineItemCount + offlineItemCount}
               data-lod={levelOfDetail}
               style={{
                 '--image-source-object-fit': objectFit
               } as any}
               className={classNames(css.root, className)}>
    <Suspense fallback={<LoadingIndicator/>}>
      {extraHeader}
      {viewMode == 'table'
       ? <div>NYI</div>
       : onlineItemCount === 0 && offlineItemCount === 0
         ? <EmptyResult>{emptyResult}</EmptyResult>
         : <CatalogItemsCardViewContainer>
           <CatalogItemsCardView_LoadMore {...props} levelOfDetail={isProductView ? settings.levelOfDetail : props.groupStore?.levelOfDetail}/>
         </CatalogItemsCardViewContainer>
      }
    </Suspense>
  </div>
  </ErrorBoundary>)
})

CatalogItemsPanel['whyDidYouRender'] = true




// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_CatalogItems/CatalogItemsPanel.tsx